// /forgot-password
import { API } from "../../apiSlice";

export const changePasswordApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    changePassword: builder.mutation({
      query: (data) => {
        return {
          url: "users/change-password",
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const { useChangePasswordMutation } = changePasswordApiSlice;
